import React from 'react';
import { WarRoomDashboard } from './pages/WarRoomDashboard';
export function App() {
  return <WarRoomDashboard data-id="element-0" />;
}